module.exports = __webpack_public_path__ + "static/media/Digit'Ed_Privacy_Policy_Prelios.cafb5fcb.pdf";